import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import { formatNumber } from "utils/currencyFormat";
import BanHangTraGopApi from "service/banHangTraGopApi";
import Select from "react-select";
import { convertToNumber } from "utils/numberExtension";

export const ThongTinChoVay = (props) => {
  let {
    data,
    register,
    chonngaygiaodich,
    IsEditChoVay,
    func,
    config,
    ChoPhepSuaMaHopDong,
    dataGoi,
  } = props;
  let { onChangeNgayVay, onChangeAttTextChoVay, setDataGoiTraGop } = func;

  let { NgayVay, ChoVayId, BeforeAfter } = data;
  const [selectedOptions, setSelectedOptions] = useState({});
  const [listGoiTraGop, setListGoiTraGop] = useState([]);
  const [valueGoiTraGop, setValueGoiTraGop] = useState("");
  const [listSanPham, setListSanPham] = useState([]);
  useEffect(() => {
    BanHangTraGopApi.listSanPhamGoi("", true, 1, 10000).then((response) => {
      if (response.status === 200) {
        const resultNew = response.data.List.map((item, index) => {
          var obj = {};
          obj.value = item.Id;
          obj.label = item.TenSanPham;
          const listGoiNew = item.lstGoi.filter(
            (item) => item.TrangThai === true
          );

          if (typeof listGoiNew !== "undefined" && listGoiNew !== null) {
            const resultGoi = listGoiNew.map((itemDetail, ii) => {
              var objGoi = {};
              objGoi.value = itemDetail.Id;
              objGoi.label =
                "Kỳ hạn " +
                itemDetail.KyHan +
                " tháng_ " +
                itemDetail.PhanTramTraTruoc +
                " %";
              objGoi.TienGoc = itemDetail.GiaGoc;
              objGoi.TienTraGop = itemDetail.GiaTraGop;
              objGoi.KyHan = itemDetail.KyHan;
              objGoi.PhanTramTraGop = itemDetail.PhanTramTraTruoc;
              return objGoi;
            });
            obj.lstGoi = resultGoi;
          }
          return obj;
        }); // lấy list chi nhánh mới gồm các trường  value (Id) và label (Name)
        setListSanPham(resultNew);
        if (data.ChoVayId > 0) {
          const objSanPhamChon = resultNew.find(
            (item) => convertToNumber(item.value) === data.IdSanPham
          );
          if (
            typeof objSanPhamChon !== "undefined" &&
            objSanPhamChon !== null
          ) {
            setSelectedOptions(objSanPhamChon);
            setListGoiTraGop(objSanPhamChon.lstGoi);
            objSanPhamChon.TienGoc = data.TienGoc;
            objSanPhamChon.TienTraGop = data.TienTraGop;
            objSanPhamChon.TienTraTruoc = data.TienTraTruoc;
            // objSanPhamChon.value = data
            setValueGoiTraGop(data.IdGoi);
            setDataGoiTraGop({
              ...dataGoi,
              IdSanPham: data.IdSanPham,
              IdGoi: data.IdGoi,
              TienGoc: data.TienGoc,
              TienTraGop: data.TienTraGop,
              KyHan: data.KyHan,
              PhanTramTraGop: data.PhanTramTraGop,
              TienTraTruoc: data.TienTraTruoc,
            });
          }
        } else {
          handleSelectChange(resultNew[0]);
        }
      }
    });
  }, []);

  const handleSelectChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    setListGoiTraGop(selectedOptions.lstGoi);
    if (selectedOptions.lstGoi.length > 0) {
      setValueGoiTraGop(selectedOptions.lstGoi[0].value);
      setDataGoiTraGop({
        ...dataGoi,
        IdSanPham: selectedOptions.value,
        IdGoi: selectedOptions.lstGoi[0].value,
        TienGoc: selectedOptions.lstGoi[0].TienGoc,
        TienTraGop: selectedOptions.lstGoi[0].TienTraGop,
        KyHan: selectedOptions.lstGoi[0].KyHan,
        PhanTramTraGop: selectedOptions.lstGoi[0].PhanTramTraGop,
        TienTraTruoc:
          selectedOptions.lstGoi[0].TienTraGop *
          (selectedOptions.lstGoi[0].PhanTramTraGop / 100),
      });
    }
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    var objGoi = listGoiTraGop.find(
      (item) => convertToNumber(item.value) === convertToNumber(e.target.value)
    );
    setValueGoiTraGop(e.target.value);
    if (typeof objGoi !== "undefined" && objGoi !== null) {
      setDataGoiTraGop({
        ...dataGoi,
        IdGoi: e.target.value,
        TienGoc: objGoi.TienGoc,
        TienTraGop: objGoi.TienTraGop,
        KyHan: objGoi.KyHan,
        PhanTramTraGop: objGoi.PhanTramTraGop,
        TienTraTruoc: objGoi.TienTraGop * (objGoi.PhanTramTraGop / 100),
      });
    } else {
      setDataGoiTraGop({
        ...dataGoi,
        IdGoi: e.target.value,
      });
    }
    console.log(e.target, "aaaaaaaaaaaaaa");
  };
  const onChangeTraGop = (field) => (e) => {
    setDataGoiTraGop({
      ...dataGoi,
      [field]: convertToNumber(e.target.value),
    });
  };
  return (
    <>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Chọn sản phẩm <span className="canh-bao-red">*</span>
        </label>
        <br />
        <Select
          value={selectedOptions}
          options={listSanPham}
          // className="form-control input-sm"
          // onChange={handleChange("sOption")}
          onChange={handleSelectChange}
          isDisabled={IsEditChoVay}
          inputWrapClass="form-control input-sm"
        />
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Chọn gói mua <span className="canh-bao-red">*</span>
        </label>
        <br />
        <select
          ref={register}
          name="nhanvien"
          className="selectBox form-control input-sm"
          value={valueGoiTraGop}
          onChange={updateDropdown("valueGoiTraGop")}
          readOnly={IsEditChoVay}
        >
          {listGoiTraGop &&
            listGoiTraGop.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Ngày mua <span className="canh-bao-red">*</span>
        </label>
        <br />
        <DateTimePicker
          onChange={onChangeNgayVay}
          value={NgayVay}
          customInputRef={register}
          readOnly={!chonngaygiaodich || IsEditChoVay}
          name="NgayVay"
          customInput={<input name="NgayVay" ref={register}></input>}
        ></DateTimePicker>
      </div>
      <div className="col-md-4">
        <TextInputTwoRow
          labelClass="col-md-2 label-control"
          inputClass="form-control input-sm"
          inputWrapClass="col-md-4"
          wrapperClass="form-group row"
          labelText="Mã hợp đồng"
          placeholder="Mã hợp đồng"
          inputProps={{
            ref: register,
            name: "Code",
            readOnly: ChoVayId ? !ChoPhepSuaMaHopDong : false,
          }}
        ></TextInputTwoRow>
      </div>
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <label className="label-control color7-bold">Giá sản phẩm</label>
        <br />
        <fieldset>
          <div className="input-group">
            <input
              value={formatNumber(dataGoi.TienGoc)}
              onChange={onChangeTraGop("TienGoc")}
              // disabled={true}
              className="form-control input-sm"
            />
          </div>
        </fieldset>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">Giá mua trả góp</label>
        <br />
        <fieldset>
          <div className="input-group">
            <input
              value={formatNumber(dataGoi.TienTraGop)}
              onChange={onChangeTraGop("TienTraGop")}
              // disabled={true}
              className="form-control input-sm"
            />
          </div>
        </fieldset>
      </div>
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Tiền trả trước <span className="canh-bao-red">*</span>
          <PopoversBootrap
            contentText="Vui lòng nhập số tiền trả trước lớn hơn hoặc bằng số tiền (giá mua trả góp x % lãi kỳ hạn)"
            titleText=""
            trigger={["hover", "focus"]}
            placement={"top"}
          >
            <i className="la la-question-circle tool-comment"></i>
          </PopoversBootrap>
        </label>
        <fieldset>
          <div className="input-group">
            <input
              value={formatNumber(dataGoi.TienTraTruoc)}
              onChange={onChangeTraGop("TienTraTruoc")}
              className="form-control input-sm"
            />
          </div>
        </fieldset>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">Tổng tiền cần thu</label>
        <br />
        <fieldset>
          <div className="input-group input-icon">
            <input
              value={formatNumber(dataGoi.TienTraGop - dataGoi.TienTraTruoc)}
              disabled={true}
              className="form-control input-sm"
            />
          </div>
        </fieldset>
      </div>
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <label className="label-control color7-bold">Góp mỗi tháng</label>
        <br />
        <fieldset>
          <div className="input-group input-icon">
            <input
              value={formatNumber(
                Math.round(
                  convertToNumber(dataGoi.TienTraGop - dataGoi.TienTraTruoc) /
                    dataGoi.KyHan
                )
              )}
              disabled={true}
              className="form-control input-sm"
            />
          </div>
        </fieldset>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          {" "}
          Kiểu thanh toán<span className="canh-bao-red">*</span>
        </label>
        <br />
        <select
          name="BeforeAfter"
          className="form-control input-sm"
          ref={register}
          value={BeforeAfter}
          onChange={onChangeAttTextChoVay("BeforeAfter")}
          readOnly={IsEditChoVay}
        >
          <option value="1">Sau</option>
          <option value="2">Trước</option>
        </select>
      </div>
    </>
  );
};
